export default [
    {
        path: '/emcadmin/plans/types',
        name: 'emcadmin-plans-types',
        component: () => import ('./views/TypeIndex'),
        meta: {
            title: 'Tipos de planos',
            icon: 'mdi-format-list-bulleted-type',
            breadcrumbs: [
                { text: 'Descrição da rota', disabled: true }
            ]
        }
    },
]
